export default __webpack_public_path__ + "static/media/planet-earth.91960a23.png";